"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSemantics = void 0;
exports.defaultSemantics = {
    toggleOff: "#ffffff",
    focus: "#ffffff",
    liked: "#ff0d50",
    positive: "#3fb950",
    negative: "#f85149",
};
//# sourceMappingURL=defaultSemantics.js.map